import { render, staticRenderFns } from "./goodsclassify.vue?vue&type=template&id=423d8f76&scoped=true&"
import script from "./goodsclassify.vue?vue&type=script&lang=js&"
export * from "./goodsclassify.vue?vue&type=script&lang=js&"
import style0 from "./goodsclassify.vue?vue&type=style&index=0&id=423d8f76&prod&lang=scss&scoped=true&"
import style1 from "./goodsclassify.vue?vue&type=style&index=1&id=423d8f76&prod&lang=scss&scoped=true&"
import style2 from "./goodsclassify.vue?vue&type=style&index=2&id=423d8f76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d8f76",
  null
  
)

export default component.exports